<template>
  <FormContainer>
    <template #title>Organisation de la formation</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_174"
          v-model="modalitePedagogiqueModel"
          label="Modalité pédagogique"
          :required="meta.formation?.modalitePedagogique?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.modalitePedagogique?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.ModalitePedagogique"
          :readonly
          key-id="code"
          key-label="intitule"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_178"
          v-model="dateDebutFormationModel"
          label="Date de début de formation en CFA"
          :required="meta.formation?.dateDebutFormationCfa?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dateDebutFormationCfa?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :readonly
        />
        <WrapperInputDate
          id="field_179"
          v-model="dateFinEpreuvesModel"
          label="Date prévue de fin des épreuves ou examens"
          :required="meta.formation?.datePrevueFinEpreuvesOuExamens?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.datePrevueFinEpreuvesOuExamens?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :readonly
        />
        <BasicAlert
          v-if="isMessageDateFinContratPlus2MoisFinFormation"
          alertType="warning"
          alertLabel="La Date de fin de contrat intervient + 2 mois et 2 jours après la date de fin de formation"
          class="col-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputNumber
          id="field_180"
          v-model="dureeFormationModel"
          label="Durée de la formation"
          :required="meta.formation?.dureeFormationEnHeures?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeFormationEnHeures?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          placeholder="Heures"
          :readonly
        />
        <WrapperInputNumber
          v-if="meta.formation?.dontDureeFormationDistance?.$status !== PropertyStatus.NotPresent"
          v-model="dontDureeFormationDistanceModel"
          :decimal="0"
          label="Dont durée de formation à distance"
          :required="meta.formation?.dontDureeFormationDistance?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dontDureeFormationDistance?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          placeholder="Heures"
          :readonly
        />
        <WrapperInputNumber
          v-else
          label="Dont durée de formation à distance"
          class="col-12 col-md-18 col-sm-36"
          placeholder="Heures"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { FormContainer, HINT_DATE, PLACEHOLDER_DATE } from '@/features/interface/demande/shared'
  import { isDateFinContratPlus2MoisFinFormation } from '@/features/domaine/regles-akto/CAPP/tools'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, readonly, lov, model } = storeToRefs(store)

  const dateDebutFormationModel = setupFieldWithKey<string>('formation.dateDebutFormationCfa', true)
  const dateFinEpreuvesModel = setupFieldWithKey<string>('formation.datePrevueFinEpreuvesOuExamens', true)
  const dureeFormationModel = setupFieldWithKey<number>('formation.dureeFormationEnHeures', true)
  const dontDureeFormationDistanceModel = setupFieldWithKey<number>('formation.dontDureeFormationDistance', true)
  const modalitePedagogiqueModel = setupFieldWithKey<string>('formation.modalitePedagogique', false)

  const isMessageDateFinContratPlus2MoisFinFormation = computed(() => {
    return isDateFinContratPlus2MoisFinFormation(
      model.value?.contrat?.dateFinContratOuPeriodeApprentissage ?? null,
      model.value?.formation?.datePrevueFinEpreuvesOuExamens ?? null,
    )
  })
</script>

